import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";
import { SystemSetting, MaintenanceModel } from "@/commons/services/SystemSettings";
import SystemSettingsService from "@/commons/services/SystemSettings";

/**
 * ### TabIndexes store
 *
 * - store
 *   - システム情報を保持する
 * - action, mutation
 *   - システム情報を設定する
 */
@Module({ name: "systemSettings" })
export default class SystemSettingStore extends VuexModule implements SystemSetting {
  /** メンテナンス */
  maintenance: MaintenanceModel = {
    status: false,
    start: 20000102030405000,
    end: 30000102030405000
  };
  version: string = "1.0.0";

  @Mutation
  private SET_SYSTEMSETTING(systemSetting: SystemSetting): void {
    this.maintenance = systemSetting.maintenance;

    return;
  }

  /**
   * ### システム設定更新
   *
   * - システム設定を更新する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public async updateSystemSetting(payload: { systemSettingsService: SystemSettingsService }): Promise<SystemSetting> {
    const systemSetting: SystemSetting = await payload.systemSettingsService.getSystemSetting();
    this.SET_SYSTEMSETTING(systemSetting);

    return systemSetting;
  }
}
